import React from 'react';
import { Container, Typography, Box, Paper } from '@mui/material';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h3" gutterBottom>
          Privacy Policy
        </Typography>
        <Typography variant="subtitle1" color="text.secondary" gutterBottom>
          Last updated: {new Date().toLocaleDateString()}
        </Typography>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom>
            1. Information We Collect
          </Typography>
          <Typography variant="body1" paragraph>
            We collect information you provide directly to us, including when you create an account, use our services, or make a purchase. This may include:
          </Typography>
          <ul>
            <li>Personal identification information (Name, email address, phone number)</li>
            <li>Business information (Company name, industry, revenue)</li>
            <li>Payment information (processed securely by Razorpay)</li>
            <li>Usage data and analytics</li>
          </ul>

          <Typography variant="h5" gutterBottom>
            2. How We Use Your Information
          </Typography>
          <Typography variant="body1" paragraph>
            We use the information we collect to:
          </Typography>
          <ul>
            <li>Provide, maintain, and improve our services</li>
            <li>Process transactions and send related information</li>
            <li>Send technical notices, updates, and support messages</li>
            <li>Respond to your comments and questions</li>
            <li>Monitor and analyze trends and usage</li>
          </ul>

          <Typography variant="h5" gutterBottom>
            3. Data Storage and Security
          </Typography>
          <Typography variant="body1" paragraph>
            We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.
          </Typography>

          <Typography variant="h5" gutterBottom>
            4. Cookies and Tracking Technologies
          </Typography>
          <Typography variant="body1" paragraph>
            We use cookies and similar tracking technologies to track activity on our service and hold certain information. You can instruct your browser to refuse all cookies.
          </Typography>

          <Typography variant="h5" gutterBottom>
            5. Third-Party Services
          </Typography>
          <Typography variant="body1" paragraph>
            We use third-party services for payment processing (Razorpay) and analytics. These third parties have access to your information only to perform these tasks on our behalf.
          </Typography>

          <Typography variant="h5" gutterBottom>
            6. Data Retention
          </Typography>
          <Typography variant="body1" paragraph>
            We will retain your personal information only for as long as is necessary for the purposes set out in this Privacy Policy.
          </Typography>

          <Typography variant="h5" gutterBottom>
            7. Your Rights
          </Typography>
          <Typography variant="body1" paragraph>
            You have the right to access, update, or delete your personal information. You can do this directly in your account settings or by contacting us.
          </Typography>

          <Typography variant="h5" gutterBottom>
            8. Children's Privacy
          </Typography>
          <Typography variant="body1" paragraph>
            Our service does not address anyone under the age of 18. We do not knowingly collect personal information from children.
          </Typography>

          <Typography variant="h5" gutterBottom>
            9. Changes to This Policy
          </Typography>
          <Typography variant="body1" paragraph>
            We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.
          </Typography>

          <Typography variant="h5" gutterBottom>
            10. Contact Us
          </Typography>
          <Typography variant="body1" paragraph>
            If you have any questions about this Privacy Policy, please contact us at service@eevolve.ai.
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default PrivacyPolicy;